/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { Tooltip } from '@scuf/common';
import './TruncatedText.scss';
import { MAGIC_VALUE } from '../Utils/Constants';
import { IObject } from '../../DashboardKPIWidgets/IEnergyManagementProps';

interface ITruncatedTextProps {
  text: string;
  style?: IObject;
  maxLength?: number;
}

const TruncateTextForNILMDisaggregation: React.FC<ITruncatedTextProps> = ({
  text,
  style,
  maxLength = MAGIC_VALUE.TWENTY
}) => {
  const renderTruncatedText = () => {
    if (text && text.length > maxLength) {
      return (
        <Tooltip
          element={
            <span
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                width: '90%'
              }}
            >
              {text}
            </span>
          }
          event="hover"
          content={text}
          position="top left"
          size="small"
          //   style={{zIndex: 1000}}
        />
      );
    }
    return <span style={style}>{text}</span>;
  };

  return renderTruncatedText();
};

export default TruncateTextForNILMDisaggregation;
